<!-- EditUniverseButton.vue -->
<template>
  <div class="has-text-centered">
    <a href="#_" v-on:click="modalOpen = true">
      <i class="fas fa-edit"></i>
    </a>
    <b-modal
      v-model="modalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <EditUniverseModal v-bind:parent="this" />
    </b-modal>
  </div>
</template>

<script>
import EditUniverseModal from './EditUniverseModal.vue';

export default {
  data() {
    return {
      modalOpen: false,
    };
  },
  components: {
    EditUniverseModal,
  },
};
</script>

<style lang="scss" scoped>
  .modal.is-active {
    .modal-card {
      background-color: #fff;
      align-self: center;
      text-transform: none;
      text-align: left;

      .b-table {
        max-height: 50vh;
        overflow: scroll;
      }
    }
  }
</style>
